// src/mappers/purchase/purchaseInvalidationMapper.ts

import { InvalidationPrefillDTO } from "../../../types/common/invalidation/InvalidationPrefillDTO";
import { PurchaseInvalidationDTO } from "../../../types/purchases/invalidation/PurchaseInvalidationDTO";
// Si moviste el DTO a "types/common/invalidation", ajusta el import.

// 1) Form vacío coherente con el nuevo modelo
export const getEmptyPurchaseInvalidationForm = (): PurchaseInvalidationDTO => ({
  documentId: null,                 // ⇠ nuevo
  generationCodeToInvalidate: "",   // ⇠ requerido
  replacementGenerationCode: null,
  invalidationTypeCode: null,       // 1 | 2 | 3
  comment: "",                      // opcional
});

// 2) PREFILL -> FORM (merge con el estado actual si se pasa)
export const mapPrefillToForm = (
  prefill: InvalidationPrefillDTO,        // { generationCode: string; documentId: number }
  current?: PurchaseInvalidationDTO | null
): PurchaseInvalidationDTO => {
  const base = current ?? getEmptyPurchaseInvalidationForm();

  return {
    ...base,
    documentId: prefill.documentId ?? base.documentId,
    generationCodeToInvalidate: prefill.generationCode ?? base.generationCodeToInvalidate,
    documentTypeCode: prefill.documentTypeCode,
  };
};

// 3) (Opcional) Mapper del form -> payload que el backend espera
export type PurchaseInvalidationCreatePayload = {
  documentId?: number | null;
  generationCodeToInvalidate: string;
  invalidationTypeCode: number;
  replacementGenerationCode?: string | null; // 🔥 AGREGAR
  comment?: string | null;
};


export const toCreatePayload = (
  form: PurchaseInvalidationDTO
): PurchaseInvalidationCreatePayload => {
  const type = String(form.invalidationTypeCode ?? '');

  const normalize = (v?: string | null) => {
    const val = v?.trim();
    return val ? val : null;
  };

  return {
    documentId: form.documentId ?? null,

    generationCodeToInvalidate:
      form.generationCodeToInvalidate?.trim() || "",

    invalidationTypeCode: Number(form.invalidationTypeCode ?? 0),

    // 🔥 SOLO cuando aplica
    replacementGenerationCode:
      ['1', '3'].includes(type)
        ? normalize(form.replacementGenerationCode)
        : null,

    comment: normalize(form.comment),
  };
};